import React from 'react'
import AtvFis from '@generators/pdfComponents/icons/AtvFisica'
import ClinNotes from '@generators/pdfComponents/icons/ClinNotes'
import Nutrition from '@generators/pdfComponents/icons/Nutrition'
import MicExternalOn from '@generators/pdfComponents/icons/MicExternalOn'
import Call from '@generators/pdfComponents/icons/Call'
import Groups from '@generators/pdfComponents/icons/Groups'
// import Pill from '@generators/pdfComponents/icons/Pill'
import Stethoscope from '@generators/pdfComponents/icons/Stethoscope'

import { Status } from '@generators/pdfComponents/Status'
import _ from 'lodash'
import {
  getDiabeticRisk,
  getHypertensiveRisk,
  getImcRisk,
  getDyslipidemiaRisk,
} from './classificationUtil'

const atvFisica = (color) => (
  <Status
    text="Atividades físicas"
    textColor={color}
    icon={() => <AtvFis color={color} />}
  />
) // atividade fisica

const clinNotes = (color) => (
  <Status
    text="Consultas médicas"
    textColor={color}
    icon={() => <ClinNotes color={color} />}
  />
) // consulta

const nutrition = (color) => (
  <Status
    text="Nutricionista"
    textColor={color}
    icon={() => <Nutrition color={color} />}
  />
) // nutricionista

const micExternalOn = (color) => (
  <Status
    text="Palestras"
    textColor={color}
    icon={() => <MicExternalOn color={color} />}
  />
) // palestra

const call = (color) => (
  <Status
    text="Acompanhamento"
    textColor={color}
    icon={() => <Call color={color} />}
  />
) // acompanhamento em nivel ambulatorial

const groups = (color) => (
  <Status
    text="Grupos de risco"
    textColor={color}
    icon={() => <Groups color={color} />}
  />
)

const stethoscope = (color) => (
  <Status
    text="Exames"
    textColor={color}
    icon={() => <Stethoscope color={color} />}
  />
)

export const statusByIcon = {
  atvFisica,
  clinNotes,
  nutrition,
  micExternalOn,
  call,
  groups,
  stethoscope
}

const shouldHideRecommendation = (label = '') => {
  const normalized = label
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()

  return normalized.startsWith('participar da palestra inform')
}

function filterRecArray(rec) {
  const usedLabels = []
  return _.filter(rec, (item) => {
    if (!item || !item.label) return false

    if (shouldHideRecommendation(item.label)) {
      return false
    }
    if (_.find(usedLabels, (usedItem) => usedItem === item.label)) return false
    usedLabels.push(item.label)
    return true
  })
}

export const getRecommendations = (newUser) => {
  const { recommendations } = newUser
  let allRecommendations = {
    imediate: [],
    nextMonths: [],
    nextYears: [],
    stageOne: [],
    stageTwo: [],
  }
  _.forEach(recommendations, (recommendation) => {
    allRecommendations = getRecommendation(newUser, recommendation, allRecommendations)
  })
  return allRecommendations
}

const getJsonFromStringField = (str) => (str && str.length ? JSON.parse(str) : null)

export const getRecommendation = (beneficiary, recommendations, allRecommendations) => {
  const {
    age, sex, lastGeneralCollection
  } = beneficiary

  const diabetic = getJsonFromStringField(recommendations.diabetic)
  const hypertensive = getJsonFromStringField(recommendations.hypertensive)
  const dyslipidemia = getJsonFromStringField(recommendations.dyslipidemia)
  const imc = getJsonFromStringField(recommendations.imc)
  const neoplasia = getJsonFromStringField(recommendations.neoplasia)

  const {
    ldlCholesterol,
    hdlCholesterol,
    triglycerides,
    systBloodPressure,
    diastBloodPressure,
    glucose,
    weight,
    height,
    totalCholesterol,
  } = lastGeneralCollection

  const hypertensiveRisk = getHypertensiveRisk(
    systBloodPressure,
    diastBloodPressure
  )

  const diabeticRisk = getDiabeticRisk(glucose)

  const dislipidemiaRisk = getDyslipidemiaRisk(
    triglycerides,
    totalCholesterol,
    hdlCholesterol,
    ldlCholesterol
  )

  const imcRisk = getImcRisk(weight, height)

  const recommendationsByCollection = allRecommendations

  if (hypertensive && hypertensiveRisk) {
    recommendationsByCollection.imediate.push(...hypertensive[hypertensiveRisk].imediate)
    recommendationsByCollection.nextMonths.push(...hypertensive[hypertensiveRisk].nextMonths)
    recommendationsByCollection.nextYears.push(...hypertensive[hypertensiveRisk].nextYears)
  }

  if (diabetic && diabeticRisk) {
    recommendationsByCollection.imediate.push(...diabetic[diabeticRisk].imediate)
    recommendationsByCollection.nextMonths.push(...diabetic[diabeticRisk].nextMonths)
    recommendationsByCollection.nextYears.push(...diabetic[diabeticRisk].nextYears)
  }

  if (dyslipidemia && dislipidemiaRisk) {
    recommendationsByCollection.imediate.push(...dyslipidemia[dislipidemiaRisk].imediate)
    recommendationsByCollection.nextMonths.push(...dyslipidemia[dislipidemiaRisk].nextMonths)
    recommendationsByCollection.nextYears.push(...dyslipidemia[dislipidemiaRisk].nextYears)
  }

  if (imc && imcRisk) {
    recommendationsByCollection.imediate.push(...imc[imcRisk].imediate)
    recommendationsByCollection.nextMonths.push(...imc[imcRisk].nextMonths)
    recommendationsByCollection.nextYears.push(...imc[imcRisk].nextYears)
  }

  if (neoplasia && (age >= neoplasia[sex].limitAge)) {
    recommendationsByCollection.stageOne = neoplasia[sex].stageOne
    recommendationsByCollection.stageTwo = neoplasia[sex].stageTwo
  }

  recommendationsByCollection.imediate = filterRecArray(recommendationsByCollection.imediate)
  recommendationsByCollection.nextMonths = filterRecArray(recommendationsByCollection.nextMonths)
  recommendationsByCollection.nextYears = filterRecArray(recommendationsByCollection.nextYears)
  recommendationsByCollection.stageOne = filterRecArray(recommendationsByCollection.stageOne)
  recommendationsByCollection.stageTwo = filterRecArray(recommendationsByCollection.stageTwo)

  return recommendationsByCollection
}
